import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { useSelector } from 'react-redux';
import { themeSelector } from './features/theme/themeSlice';
import { userSelector } from './features/user/userSlice';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Navigation from './components/Navigation';
import Home from './components/Home';
import Login from './features/user/Login';
import Logout from './features/user/Logout';

import CreateMaintenanceTask from './features/maintenance/CreateMaintenanceTask';
import MaintenanceTaskList from './features/maintenance/MaintenanceTaskList';
import MaintenanceTaskDetails from './features/maintenance/MaintenanceTaskDetails';
import ReportMaintenanceTasks from './features/report/ReportMaintenanceTasks';

// import Users from './features/user/Users';

import Manage from './features/manage/ManageLayout';

import Box from '@mui/material/Box';

// const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

// const theme = React.useMemo(
//   () =>
//     createTheme({
//       palette: {
//         mode: prefersDarkMode ? 'dark' : 'light',
//       },
//     }),
//   [prefersDarkMode],
// );

const themeLight = createTheme({
  palette: {
    mode: 'light',
    primary: {
      light: '#86993c',
      main: '#576b0a',
      dark: '#2c4000',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#ffff56',
      main: '#ffed00',
      dark: '#c7bb00',
      contrastText: '#000000',
    },
  },
});

const themeDark = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      light: '#dde7b5',
      main: '#abb585',
      dark: '#7b8558',
      contrastText: '#000000',
    },
    secondary: {
      light: '#86993c',
      main: '#576b0a',
      dark: '#2c4000',
      contrastText: '#ffffff',
    },
  },
});

function App() {
  const { theme } = useSelector(themeSelector);

  const { user } = useSelector(userSelector);

  // if (!user) {
  //   return redirect('/login');
  // }

  return (
    <ThemeProvider theme={theme === 'dark' ? themeDark : themeLight}>
      <CssBaseline />
      <BrowserRouter>
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss={false}
          draggable={false}
          pauseOnHover
          limit={5}
        />
        <Box sx={{ minHeight: '100vh' }}>
          {/* <Box sx={{ minHeight: '100vmin', bgcolor: 'coral' }}> */}
          <Navigation />
          {!user ? <Navigate to="/login" replace /> : null}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />

            <Route
              path="/create-maintenance-task"
              element={<CreateMaintenanceTask />}
            />
            <Route
              path="/maintenance-task-list"
              element={<MaintenanceTaskList />}
            />
            <Route
              path="/maintenance-task-list/details"
              element={<MaintenanceTaskDetails />}
            />
            <Route
              path="/report-maintenance-tasks"
              element={<ReportMaintenanceTasks />}
            />
            {/* <Route path="/users/*" element={<Users />} /> */}
            <Route path="/manage-layout" element={<Manage />} />
          </Routes>
        </Box>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
